<template lang="html">
  <nav>
    <ul>
<!--      <li><router-link :to="{ name: 'ColoursPage', params: {} }">Colours</router-link></li>-->
      <li><router-link :to="{ name: 'WelcomePage', params: {} }">Welcome Screen</router-link></li>
      <li><router-link :to="{ name: 'WidgetsPage', params: {} }">Widgets</router-link></li>
<!--      <li><router-link :to="{ name: 'BannersPage', params: {} }">Banners</router-link></li>-->
<!--      <li><router-link :to="{ name: 'ReceiptEmailPage', params: {} }">Receipt Email</router-link></li>-->
      <li><router-link :to="{ name: 'CollectedPage', params: {} }">Collected Emails</router-link></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "MarketingSubheader"
}
</script>

<style lang="css" scoped>
nav ul{
  list-style: none;
  padding: 0;
  border-bottom: 3px solid rgb(227, 70, 150);
}

nav ul li{
  display: inline-block;
  margin-right: 30px;
  border: 1px solid rgb(227, 70, 150);
  font-size: 14px;
  border-radius: 3px;
}

nav ul li a{
  background-color: transparent;
  width: 163px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: rgb(227, 70, 150);
  font-weight: bold;
}

.router-link-active{
  background-color: #D1CAE4;
}
</style>
